import { FileManagement } from "../models/file-management.model";
import { addUniqueName, dateFormat } from "../utils/helper";
import { FILE_MANAGEMENT } from "./file-management.constants";

const initalState = {
  fileList: [] as FileManagement[],
  fullfileList: [] as FileManagement[],
  searchValue: "",
  userDetails: {} as any,
  storageDetails: {} as any,
  rowKey: "",
  uploadPercentage: {
    percentage: 0,
    fileName: "",
    status:0
  } as any,
};

const updateState = (payload: any) => {
  return {
    fileList: payload,
    fullfileList: payload,
  };
};

export const fileManagementReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case FILE_MANAGEMENT.FILE_MANAGEMENT_LISTS:
      return {
        ...state,
        ...updateState(action.payload?.map((i: any) => ({ ...i, checked: false }))),
      };
    case FILE_MANAGEMENT.FETCH_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };
    case FILE_MANAGEMENT.ADD_NEW_FOLDER:
      const fileName = addUniqueName(state.fileList, "My_Folder");
      console.log("fileName", state);
      return {
        ...state,
        ...updateState([
          {
            id: null,
            fileName: fileName,
            path: fileName,
            updatedAt: dateFormat(new Date()),
            updatedBy: state?.userDetails?.email,
            source: "Web",
            fileType: "folder",
            textBox: true,
            fileSize: 0,
          },
          ...state.fullfileList,
        ]),
      };

    case FILE_MANAGEMENT.GET_STORAGE_DETAILS:
      return {
        ...state,
        storageDetails: action.payload,
      };

    case FILE_MANAGEMENT.RESET_TO_ORIGINAL_STATE:
      return {
        ...state,
        ...updateState(
          state.fullfileList?.map((item) => {
            item.checked = false;
            return item;
          })
        ),
      };

    case FILE_MANAGEMENT.CHECK_ALL_CHECKBOX:
      const updatedCheckIsoFileList = state.fileList.map((item) => {
        item.checked = action.payload;
        return item;
      });

      return {
        ...state,
        ...updateState(updatedCheckIsoFileList),
      };

    case FILE_MANAGEMENT.CHECK_SINGLE_CHECKBOX:
      const { id, value } = action.payload;
      const updatedSingleSelectIsoFileList = state.fileList.map(
        (item, index) => {
          if (index === id) {
            item.checked = value;
          }
          return item;
        }
      );
      return {
        ...state,
        ...updateState(updatedSingleSelectIsoFileList),
      };

    case FILE_MANAGEMENT.SORTING_ORDER:
      const { direction, key } = action.payload;
      const typedKey = key as keyof FileManagement;

      const sortedFileList = [...state.fileList].sort((a, b) => {
        if (key === "fileName") {
          const getFolderName = (item: FileManagement) => {
            if (item?.fileName) {
              return item.fileName.toString();
            } else if (item?.path) {
              return item.path.split("/").filter(Boolean)[0]?.toString() || "";
            }
            return "";
          };

          const aFolder = getFolderName(a);
          const bFolder = getFolderName(b);

          if (direction === "asc") return aFolder.localeCompare(bFolder);
          if (direction === "desc") return bFolder.localeCompare(aFolder);
          return 0;
        } else if (key === "fileSize") {
          const aSize = Number(a.fileSize) || 0;
          const bSize = Number(b.fileSize) || 0;
          if (direction === "asc") return aSize - bSize;
          if (direction === "desc") return bSize - aSize;
          return 0;
        }

        const aVal = (a[typedKey] ?? "").toString();
        const bVal = (b[typedKey] ?? "").toString();
        if (direction === "asc") return aVal.localeCompare(bVal);
        if (direction === "desc") return bVal.localeCompare(aVal);
        return 0;
      });
      return {
        ...state,
        ...updateState(sortedFileList),
      };
    case FILE_MANAGEMENT.SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload
      };
    case FILE_MANAGEMENT.UPDATE_FILE_NAME:
      const updatedCheckAllFileList = state.fileList.map((item, index) => {
        if (index === action.payload?.index) {
          item.fileName = action.payload?.value ? action.payload?.value : null;
          return item;
        }
        return item;
      });
      return {
        ...state,
        ...updateState(updatedCheckAllFileList),
      };

    case FILE_MANAGEMENT.SEARCH_FILTER:
      return {
        ...state,
        fileList: state.fullfileList.filter(
          (item) =>
            item.fileName
              ?.toLowerCase()
              .includes(action.payload.toLowerCase()) ||
            item.path?.toLowerCase().includes(action.payload.toLowerCase())
        ),
      };

    case FILE_MANAGEMENT.SEARCH_FETCH_FILTER:
      return {
        ...state,
        fileList: action.payload,
      };

    case FILE_MANAGEMENT.CLEAR_FILTER:
      return {
        ...state,
        ...updateState(state.fullfileList),
      };

    case FILE_MANAGEMENT.UPDATE_FOLDER_NAME:
      const updatedCheckAllFolderList = state.fileList.map((item, index) => {
        item.textBox = false;
        return item;
      });
      return {
        ...state,
        ...updateState(updatedCheckAllFolderList),
      };

    case FILE_MANAGEMENT.ROW_KEY:
      return {
        ...state,
        rowKey: action.payload,
      };

    case FILE_MANAGEMENT.UPLOAD_PERCENTAGE:
      return {
        ...state,
        uploadPercentage: {
          percentage: action.payload?.percentage || 0,
          fileName: action.payload?.fileName || "",
          status: action.payload?.status
        },
      };

    default:
      return state;
  }
};
